import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LRV } from '../models/Lead-reseller-vf';
import { environment } from 'src/environments/environment';
import { IGenericResponse } from '../models/IGenericResponse';
@Injectable({
  providedIn: 'root'
})
export class LeadResellerVodafoneService {

  private http = inject(HttpClient);
  private url = environment.api;

  constructor() { }

  nuevoUsuarioLRV(formulario: LRV) {
    console.log("Llamada nuevoUsuario: ", this.url + "/registro/nuevoCliente");
    return this.http.post<IGenericResponse>(this.url + "/registro/nuevoCliente", formulario); 
  }

  enviarSMS(telefono: string){
    console.log("Llamada enviarSMS: ", this.url + "/registro/enviarSMS");
    return this.http.post<IGenericResponse>(this.url + "/registro/enviarSMS", {telefono}); 
  }
  validarDistribuidor(distribuidor: string){
    console.log("Llamada enviarSMS: ", this.url + "/registro/validarDistribuidor");
    return this.http.get<IGenericResponse>(this.url + "/registro/validarDistribuidor/" + distribuidor); 
  }
}